import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { User } from "@customTypes/user";

import { userQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: User[] = [];

    for (const i in res.data) {
      const { _id, full_name, roles, username, email } = res.data[i];

      newData.push({
        id: _id,
        username,
        email,
        fullName: full_name,
        roles: Array.isArray(roles) ? roles : [roles],
      });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

export const useGetUsers = ({ role, permission, accountOptions = false, isEnabled = true }: { role?: string; permission?: string; accountOptions?: boolean; isEnabled?: boolean }) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: [...userQKeys.allWithFilters({ role }), permission, { accountOptions }],
    queryFn: () => {
      return api.get(accountOptions ? 'user/options' : 'user/users', { params: { role, permission } });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get All Users]", res);
      handleErrors(res, "query");
    },
  });
};
